import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  variant?: 'default' | 'elevated' | 'outlined';
  onClick?: () => void;
  role?: string;
  tabIndex?: number;
  'aria-expanded'?: boolean;
  onKeyDown?: (e: React.KeyboardEvent) => void;
}

export default function Card({
  children,
  className = '',
  hover = true,
  variant = 'default',
  onClick,
  role,
  tabIndex,
  'aria-expanded': ariaExpanded,
  onKeyDown
}: CardProps) {
  const baseClasses = 'rounded-lg transition-all duration-300';
  
  const variantClasses = {
    default: 'bg-card border border-border',
    elevated: 'bg-card border border-border shadow-lg',
    outlined: 'bg-background border border-border'
  };

  const hoverClasses = hover 
    ? 'hover:border-primary hover:shadow-neon-cyan' 
    : '';

  const interactiveClasses = onClick ? 'cursor-pointer' : '';

  // Use provided handlers or default behavior
  const handleKeyDown = onKeyDown || (onClick ? (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  } : undefined);

  return (
    <div
      className={`${baseClasses} ${variantClasses[variant]} ${hoverClasses} ${interactiveClasses} ${className}`}
      onClick={onClick}
      role={role || (onClick ? 'button' : undefined)}
      tabIndex={tabIndex !== undefined ? tabIndex : (onClick ? 0 : undefined)}
      aria-expanded={ariaExpanded}
      onKeyDown={handleKeyDown}
    >
      {children}
    </div>
  );
}

